<div style="display: flex; justify-content: start;  margin: 5px;font-size:small;flex-wrap: wrap;">
  @if(this.SkillsGroups.length==0){
    <div style="font-style: italic; color: gray;">No skills evaluated</div>
  }
  @for (group of this.SkillsGroups; track group.SkillGroupId) {
    <div style="display: flex; flex-direction: column; margin-right: 10px; ">
      
      <b>{{group.Name}}</b>
      @for (skill of group.Skills; track skill.SkillId) {
        <div style="display: flex; flex-direction: row; margin-left: 10px;">
          <div style="width: 250px;">{{skill.Text}}</div>
          <div [class]="this.classesRankingBox[skill.Ranking]">{{skill.Ranking}}</div>
        </div>
        
      }
    </div>
    <mat-divider></mat-divider>
  }
</div>
